/**
 * ระบบเควสและภารกิจ (Quest System)
 *
 * จัดการข้อมูลเควส เงื่อนไขการรับเควส และการตรวจสอบความสำเร็จ
 * ใช้งานร่วมกันทั้ง Client และ Server โดยไม่ผูกกับ Network
 */
import questsJson from "./data/quests.json" with { type: "json" };
export const QUEST_LIST = questsJson;
export const QUESTS = Object.freeze(Object.fromEntries(QUEST_LIST.map((q) => [q.id, q])));
/** ดึงข้อมูลเควสตาม id */
export function getQuest(id) {
    return QUESTS[id];
}
/** เควสที่อาชีพนี้มองเห็น (ตัดเควสเลื่อนขั้นของสายอื่น — อาชีพขั้นสูงยังเห็นเควสของสายเดิมที่ทำจบแล้ว) */
export function questsForClass(classId, baseClassId) {
    return QUEST_LIST.filter((q) => !q.reqClass?.length
        || (!!classId && q.reqClass.includes(classId)) || (!!baseClassId && q.reqClass.includes(baseClassId)));
}
/** ดึงรายการเควสทั้งหมด */
export function getAllQuests() {
    return QUEST_LIST;
}
/**
 * ตรวจสอบว่าผู้เล่นสามารถรับเควสนี้ได้หรือไม่
 */
export function isQuestAvailable(quest, playerLevel, completedQuestIds, classId) {
    if (playerLevel < quest.minLevel)
        return false;
    if (quest.reqClass?.length && (!classId || !quest.reqClass.includes(classId)))
        return false;
    const completed = completedQuestIds instanceof Set ? completedQuestIds : new Set(completedQuestIds);
    if (completed.has(quest.id))
        return false;
    if (quest.prerequisiteQuestId && !completed.has(quest.prerequisiteQuestId)) {
        return false;
    }
    return true;
}
/**
 * ตรวจสอบว่าเป้าหมายนี้เสร็จสิ้นหรือยัง
 */
export function isObjectiveComplete(objective, currentCount) {
    return (currentCount ?? 0) >= objective.targetCount;
}
/**
 * ตรวจสอบว่าเควสทำเงื่อนไขครบทุกข้อและพร้อมส่งรับรางวัลหรือยัง
 * สำหรับ collect_item จะอ่านจำนวนไอเทมที่มีในกระเป๋าผ่าน getItemCount
 */
export function isQuestReadyToClaim(quest, progress, getItemCount) {
    for (const obj of quest.objectives) {
        if (obj.type === "collect_item") {
            const have = getItemCount ? getItemCount(obj.targetId) : (progress[obj.id] ?? 0);
            if (have < obj.targetCount)
                return false;
        }
        else {
            const done = progress[obj.id] ?? 0;
            if (done < obj.targetCount)
                return false;
        }
    }
    return true;
}
/** เที่ยงคืนเวลาไทยตัดวัน */
const DAY_MS = 86_400_000;
const TH_OFFSET_MS = 7 * 3_600_000;
/** หมายเลขวันตามเวลาไทย */
export function thaiDayIndex(nowMs) {
    return Math.floor((nowMs + TH_OFFSET_MS) / DAY_MS);
}
/**
 * ลบเควสรายวันที่ทำสำเร็จ "ก่อนวันนี้" ออกจาก records เพื่อให้รับใหม่ได้
 * เควสที่ยังค้างอยู่ (active) ไม่แตะ ผู้เล่นทำต่อข้ามวันได้
 * คืนรายการ questId ที่ถูกรีเซ็ต เพื่อให้ผู้เรียกลบแถวในฐานข้อมูลด้วย
 */
export function refreshRepeatables(records, nowMs = Date.now()) {
    const today = thaiDayIndex(nowMs);
    const reset = [];
    for (const [id, rec] of records) {
        if (rec.status !== "completed")
            continue;
        if (QUESTS[id]?.repeat !== "daily")
            continue;
        if (rec.completedAt === undefined || thaiDayIndex(rec.completedAt) < today) {
            records.delete(id);
            reset.push(id);
        }
    }
    return reset;
}
//# sourceMappingURL=quests.js.map